let Prismic = require("prismic-javascript");
const PrismicDOM = require("prismic-dom");
Prismic = Prismic.default;



let linkResolver = function(doc) {
  // Pretty URLs for known types
  if (doc.type === "update") return "/update/" + getCurrentId();
  if (doc.type === "page") return "/" + getCurrentId();
  // Fallback for other types, in case new custom types get created
  return "/doc/" + getCurrentId();
  console.log(doc.uid);
};

let Elements = PrismicDOM.RichText.Elements;
let htmlSerializer = function(type, element, content, children) {
  switch (type) {
    case Elements.heading1:
      return `<h1>${children.join("")}</h1>`;
    case Elements.heading2:
      return `<h2>${children.join("")}</h2>`;
    case Elements.heading3:
      return `<h3>${children.join("")}</h3>`;
    case Elements.heading4:
      return `<h4>${children.join("")}</h4>`;
    case Elements.heading5:
      return `<h5>${children.join("")}</h5>`;
    case Elements.heading6:
      return `<h6>${children.join("")}</h6>`;
    case Elements.paragraph:
      return `<p>${children.join("")}</p>`;
    case Elements.preformatted:
      return `<pre>${children.join("")}</pre>`;
    case Elements.strong:
      return `<strong>${children.join("")}</strong>`;
    case Elements.em:
      return `<em>${children.join("")}</em>`;
    case Elements.listItem:
      return `<li>${children.join("")}</li>`;
    case Elements.oListItem:
      return `<li>${children.join("")}</li>`;
    case Elements.list:
      return `<ul id="u-list">${children.join("")}</ul>`;
    case Elements.oList:
      return `<ol id="o-list">${children.join("")}</ol>`;
    case Elements.image:
      let linkUrl = element.linkTo
        ? PrismicDOM.Link.url(element.linkTo, module.exports.linkResolver)
        : null;
      let linkTarget =
        element.linkTo && element.linkTo.target
          ? `target="${element.linkTo.target}" rel="noopener"`
          : "";
      let wrapperClassList = [element.label || "", "block-img"];
      let img = `<img src="${element.url}" alt="${element.alt ||
        ""}" copyright="${element.copyright || ""}">`;
      return `
          <p class="${wrapperClassList.join(" ")}">
            ${
              linkUrl
                ? `<a ${linkTarget} class="link" href="${linkUrl}"> ${img}</a>`
                : img
            }
          </p>
        `;
    case Elements.embed:
      return `
          <div data-oembed="${element.oembed.embed_url}"
            data-oembed-type="${element.oembed.type}"
            data-oembed-provider="${element.oembed.provider_name}"
          >
            ${element.oembed.html}
          </div>
        `;
    case Elements.hyperlink:
      target = element.data.target
        ? `target="${element.data.target}" rel="noopener"`
        : "";
      linkUrl = PrismicDOM.Link.url(element.data, linkResolver);
      return `<a class="link" ${target} href="${linkUrl}">${children.join(
        ""
      )}</a>`;
    case Elements.label:
      label = element.data.label ? ` class="${element.data.label}"` : "";
      return `<span ${label}>${children.join("")}</span>`;
    case Elements.span:
      return content ? content.replace(/\n/g, "<br />") : "";
    default:
      return null;
  }
};

getCurrentId = () => {
  const currentUid = document.getElementsByClassName("article")[0].id;
  return currentUid;
};


window.addEventListener('DOMContentLoaded', (event) => 
{

      if (json) {
        const wrap = document.querySelector(".article-wrap");
        const articleDate = document.createElement("p");
        articleDate.classList.add("article-wrap-post-date");

        let crossBrowserDate = new Date().toLocaleDateString(
            "en-US",
            {
              day: "numeric",
              month: "short",
              year: "numeric",
            }
        );

        if (typeof json.first_publication_date && json.first_publication_date){

          const pureDate = Date.parse(
            json.first_publication_date.slice(0, -5)
          );
          let lastVisit = localStorage.getItem("last-visit");
          let lastPost = new Date(json.first_publication_date)/1000;
          if (parseInt(lastPost) > parseInt(lastVisit) || isNaN(parseInt(lastVisit))) {
            localStorage.setItem("last-visit",lastPost);
          }

          //console.log('pure date :' + pureDate)
          crossBrowserDate = new Date(pureDate).toLocaleDateString(
            "en-US",
            {
              day: "numeric",
              month: "short",
              year: "numeric",
            }
          );
        }


        articleDate.innerHTML = crossBrowserDate;
        wrap.appendChild(articleDate);

        const articleElement = document.querySelector("#article-element");
        const articleTitle = document.createElement("p");
        articleTitle.classList.add("post-title");
        articleTitle.innerHTML = json.data.title[0].text;
        articleElement.appendChild(articleTitle);

        if (json.data.image.url) {
          const articleImage = document.createElement("img");
          articleImage.classList.add("post-image");
          articleImage.src = json.data.image.url;
          articleElement.appendChild(articleImage);
        }
        const articleFullText = document.createElement("div");
        articleFullText.classList.add("text-content");
        /*console.log(json.data);*/
        if (json.data.content) {
          /*console.log("warn1");*/
          articleFullText.innerHTML = PrismicDOM.RichText.asHtml(
            json.data.content,
            linkResolver,
            htmlSerializer
          );
        } else {
          /*console.log("warn2");*/
          articleFullText.innerHTML = PrismicDOM.RichText.asHtml(
            json.data.article_text,
            linkResolver,
            htmlSerializer
          );
        }

        articleElement.appendChild(articleFullText);

      }


    });
